module.exports = __webpack_public_path__ + "img/mobil80.25ae80cb.png";